import React from "react";
import PropTypes from "prop-types";
import difference from "lodash.difference";
// import { connect } from "react-redux";
// import { enableVoice, disableVoice } from "./store/actions";
import Keyboard from "./Keyboard";

class ControlledPiano extends React.Component {
  static propTypes = {
    activeNotes: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
    playNote: PropTypes.func.isRequired,
    stopNote: PropTypes.func.isRequired,
    onPlayNoteInput: PropTypes.func.isRequired,
    onStopNoteInput: PropTypes.func.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    // width: PropTypes.number,
    // keyWidthToHeight: PropTypes.number,
  };

  state = {
    isMouseDown: false,
    useTouchEvents: false,
  };

  componentDidMount() {
    window.addEventListener("keydown", this.onKeyDown);
    window.addEventListener("keyup", this.onKeyUp);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKeyDown);
    window.removeEventListener("keyup", this.onKeyUp);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.activeNotes !== prevProps.activeNotes) {
      this.handleNoteChanges({
        prevActiveNotes: prevProps.activeNotes || [],
        nextActiveNotes: this.props.activeNotes || [],
      });
    }
  }

  // This function is responsible for diff'ing activeNotes
  // and playing or stopping notes accordingly.
  handleNoteChanges = ({ prevActiveNotes, nextActiveNotes }) => {
    if (this.props.disabled) {
      return;
    }
    const notesStopped = difference(prevActiveNotes, nextActiveNotes);
    const notesStarted = difference(nextActiveNotes, prevActiveNotes);
    notesStarted.forEach((midiNumber) => {
      this.props.playNote(midiNumber);
    });
    notesStopped.forEach((midiNumber) => {
      this.props.stopNote(midiNumber);
    });
  };

  // getMidiNumberForKey = (key) => {
  //   if (!this.props.keyboardShortcuts) {
  //     return null;
  //   }
  //   const shortcut = this.props.keyboardShortcuts.find((sh) => sh.key === key);
  //   return shortcut && shortcut.midiNumber;
  // };

  // onKeyDown = (event) => {
  //   // Don't conflict with existing combinations like ctrl + t
  //   if (event.ctrlKey || event.metaKey || event.shiftKey) {
  //     return;
  //   }
  //   const midiNumber = this.getMidiNumberForKey(event.key);
  //   if (midiNumber) {
  //     this.onPlayNoteInput(midiNumber);
  //   }
  // };

  // onKeyUp = (event) => {
  //   // This *should* also check for event.ctrlKey || event.metaKey || event.ShiftKey like onKeyDown does,
  //   // but at least on Mac Chrome, when mashing down many alphanumeric keystrokes at once,
  //   // ctrlKey is fired unexpectedly, which would cause onStopNote to NOT be fired, which causes problematic
  //   // lingering notes. Since it's fairly safe to call onStopNote even when not necessary,
  //   // the ctrl/meta/shift check is removed to fix that issue.
  //   const midiNumber = this.getMidiNumberForKey(event.key);
  //   if (midiNumber) {
  //     this.onStopNoteInput(midiNumber);
  //   }
  // };

  onPlayNoteInput = (midiNumber) => {
    if (this.props.disabled) {
      return;
    }
    // Pass in previous activeNotes for recording functionality
    this.props.onPlayNoteInput(midiNumber, this.props.activeNotes);
  };

  onStopNoteInput = (midiNumber) => {
    if (this.props.disabled) {
      return;
    }
    // Pass in previous activeNotes for recording functionality
    this.props.onStopNoteInput(midiNumber, this.props.activeNotes);
  };

  onMouseDown = () => {
    this.setState({
      isMouseDown: true,
    });
  };

  onMouseUp = () => {
    this.setState({
      isMouseDown: false,
    });
  };

  onTouchStart = () => {
    this.setState({
      useTouchEvents: true,
    });
  };

  render() {
    return (
      <div
        style={{ width: "100%", height: "100%" }}
        onMouseDown={this.onMouseDown}
        onMouseUp={this.onMouseUp}
        onTouchStart={this.onTouchStart}
        data-testid="container"
      >
        {/* <div
          style={{
            width: "100%",
            height: "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {this.props.voiceDetect ? (
            <button onClick={this.props.disableVoice}>
              {" "}
              Stop Voice Detection
            </button>
          ) : (
            <button onClick={this.props.enableVoice}> Detect Voice</button>
          )}
        </div> */}
        <Keyboard
          onPlayNoteInput={this.onPlayNoteInput}
          onStopNoteInput={this.onStopNoteInput}
          activeNotes={this.props.activeNotes}
          className={this.props.className}
          disabled={this.props.disabled}
          // width={this.props.width}
          // keyWidthToHeight={this.props.keyWidthToHeight}
          gliss={this.state.isMouseDown}
          useTouchEvents={this.state.useTouchEvents}
        />
      </div>
    );
  }
}

// const mapStateToProps = (state) => {
//   return {
//     config: state.config,
//     voiceDetect: state.voiceDetect,
//   };
// };

// const mapDispatchToProps = {
//   enableVoice,
//   disableVoice,
// };

// export default connect(mapStateToProps, mapDispatchToProps)(ControlledPiano);
export default ControlledPiano;
